import React from "react"
import PropTypes from "prop-types"

import SelectButton from '../../form_sections/SelectButton';
import StandardModal from '../../app_components/StandardModal';

class GenderFilter extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      needGenderModal: false
    }
    this.userGenderText = this.userGenderText.bind(this)
    this.needGenderModal = this.needGenderModal.bind(this)
    this.selectGender = this.selectGender.bind(this)
  }

  userGenderText() {
    switch (this.props.userGender) {
      case 2:
        return 'Women'
        break;
      case 3:
        return 'Men'
        break;
      default:
        return 'Undefined'
    }
  }

  selectGender(userGender) {
    //if gender is not defined, prompt user to update account
    if(this.props.userGender !=  2 && this.props.userGender !=  3) {
      this.setState({
        needGenderModal: true
      })
    }
    //if user isn't Pro, prompt user to upgrade
    else if (!this.props.premiumUser) {
      this.props.toggleProModal('filter')
    }
    else {
      //if filter, set filter
      this.props.updateGender(userGender)
    }

  }

  needGenderModal() {
    return(
      <StandardModal onClose={() => this.setState({needGenderModal: false})}>
        <h3 className="sectionText" style={{padding: 15}}>You need to save your gender to use this filter.</h3>
        <button className="button_primary" onClick={() => window.location.replace('/edit')}>Go to my settings</button>
      </StandardModal>)
  }

  render() {
    return(
      <div className="filterSection">
        {this.state.needGenderModal && this.needGenderModal()}
        <div style={{display: 'flex', flexDirection: ''}}>
          <h4 className="sectionHeader">Gender</h4>
          <h4 className="proHeader" style={{paddingLeft: 15}}>Pro Filter</h4>
        </div>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <SelectButton
            selected={this.props.selectedGender > 1}
            onClick={() => this.selectGender(this.props.userGender)}
            buttonText={`My Gender (${this.userGenderText()})`} />
          <SelectButton
            selected={this.props.selectedGender < 2}
            onClick={() => this.selectGender(1)}
            buttonText={"Everyone"} />
        </div>
      </div>
    )
  }
}

export default GenderFilter;
